/* unplugin-vue-components disabled */import script from "./contentPanel.vue?vue&type=script&lang=js"
export * from "./contentPanel.vue?vue&type=script&lang=js"

import "./contentPanel.vue?vue&type=style&index=0&id=582b8a06&lang=scss"

const __exports__ = script;

export default __exports__